module.exports = __webpack_public_path__ + "static/media/goat_eating.3326511a.png";